import api from './api';

/**
 * Customer Service
 * API calls for customer portal functionality
 */
export const customerService = {
  // Authentication
  login: async (mobile, password) => {
    return await api.post('/customer/auth/login', { mobile, password });
  },

  getProfile: async () => {
    return await api.get('/customer/auth/me');
  },

  // Dashboard
  getDashboard: async () => {
    return await api.get('/customer/dashboard');
  },

  // Transactions
  getTransactions: async (params = {}) => {
    return await api.get('/customer/transactions', { params });
  },

  // Payment Summary
  getPaymentSummary: async () => {
    return await api.get('/customer/payment-summary');
  }
};
